<template>
	<div>
		<div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
			<div class="modal-dialog modal-full-width">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Koszty delegacji</h5>
						<button type="button" class="close ms-auto" data-bs-dismiss="modal">
							<span>&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h6 class="mb-0">Lista kosztów delegacji</h6>
							<button v-if="!readonly" class="btn btn-sm btn-success" @click="addKoszta"><i
									class="bi bi-plus-lg me-1"></i> Dodaj
								koszta</button>
						</div>
						<div class="custom-table">
							<table class="table table-hover table-bordered">
								<thead>
									<tr>
										<th>#</th>
										<th>Kwota</th>
										<th>Waluta</th>
										<th>Typ</th>
										<th>Metoda płatności</th>
										<th>Data</th>
										<th>Kurs</th>
										<th>Akcje</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="addingNew">
										<td>#</td>
										<td>
											<input v-model="newKoszta.kwota" type="number" step="0.01"
												class="form-control">
										</td>
										<td>
											<select v-model="newKoszta.waluta" class="form-select">
												<option v-for="c in currencys" :key="c.id" :value="c.name">
													{{ c.name }}
												</option>
											</select>
										</td>
										<td>
											<select v-model="newKoszta.typ" class="form-select">
												<option v-for="t in typyKosztow" :key="t.id" :value="t.id">
													{{ t.name }}
												</option>
											</select>
										</td>
										<td>
											<select v-model="newKoszta.metoda" class="form-select">
												<option value="0">Gotówka</option>
												<option value="1">Karta</option>
												<option value="2">Przelew</option>
												<option value="3">PayPal/Revolut</option>
											</select>
										</td>
										<td>
											<input type="date" v-model="newKoszta.data" class="form-control">
										</td>
										<td></td>
										<td>
											<button class="btn btn-success btn-sm me-1"
												@click="saveNewKoszta">Zapisz</button>
											<button class="btn btn-danger btn-sm"
												@click="cancelNewKoszta">Anuluj</button>
										</td>
									</tr>
									<tr v-for="(koszta, index) in lokalneKoszty" :key="koszta.id ?? index">
										<td>{{ index + 1 }}</td>
										<td>
											<input v-if="editingId === koszta.id" v-model="koszta.kwota" type="number"
												step="0.01" class="form-control" />
											<span v-else>{{ koszta.kwota }}</span>
										</td>
										<td>
											<select v-if="editingId === koszta.id" v-model="koszta.waluta"
												class="form-select" style="max-width:100px;">
												<option v-for="c in currencys" :key="c.id" :value="c.name">{{ c.name }}
												</option>
											</select>
											<span v-else>{{ koszta.waluta }}</span>
										</td>
										<td>
											<select v-if="editingId === koszta.id" v-model="koszta.typ"
												class="form-select">
												<option v-for="t in typyKosztow" :key="t.id" :value="t.id">
													{{ t.name }}
												</option>
											</select>
											<span v-else>
												{{ getTypName(koszta.typ) }}
											</span>
										</td>
										<td>
											<select v-if="editingId === koszta.id" v-model="koszta.metoda" class="form-select">
												<option value="0">Gotówka</option>
												<option value="1">Karta</option>
												<option value="2">Przelew</option>
												<option value="3">PayPal/Revolut</option>
											</select>
											<span v-else>
												{{ koszta.metoda == 0
													? 'Gotówka'
													: koszta.metoda == 1
														? 'Karta'
														: koszta.metoda == 2
															? 'Przelew'
															: koszta.metoda == 3
																? 'PayPal/Revolut'
																: ''
												}}
											</span>
										</td>
										<td>
											<input v-if="editingId === koszta.id" type="date" v-model="koszta.data"
												class="form-control">
											<span v-else>{{ koszta.data }}</span>
										</td>
										<td v-if="koszta.waluta != 'PLN'">{{ Number(koszta.kurs).toFixed(4) }} PLN</td>
										<td v-else> --- </td>
										<td>
											<button v-if="!readonly && editingId === koszta.id"
												@click="updateKoszta(koszta)"
												class="btn btn-sm btn-success me-2">Zapisz</button>
											<button v-else-if="!readonly" @click="editKoszta(koszta.id)"
												class="btn btn-sm btn-outline-info me-2"><i
													class="bi bi-pencil me-2"></i>Edytuj</button>
											<button v-if="!readonly" @click="deleteKoszta(koszta.id)"
												class="btn btn-sm btn-danger"><i
													class="bi bi-trash me-2"></i>Usuń</button>
										</td>
									</tr>

								</tbody>
							</table>
						</div>
					</div>


					<div class="modal-footer">
						<button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { Modal } from 'bootstrap';
import { ComboBoxComponent } from "@syncfusion/ej2-vue-dropdowns";

export default {
	props: {
		currencys: { type: Array, default: () => [] },
		delegacja: {
			type: Object,
			default: null
		},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	components: {
		'ejs-combobox': ComboBoxComponent
	},
	data() {
		return {
			modalObj: null,
			editingId: null,
			addingNew: false,
			lokalneKoszty: [],
			typyKosztow: [
				{ id: 1, name: 'Paliwo' },
				{ id: 2, name: 'Jedzenie' },
				{ id: 3, name: 'Hotel' },
				{ id: 4, name: 'Drogi płatne' },
				{ id: 5, name: 'Części/Inne' },
				{ id: 6, name: 'Dieta' },
				{ id: 7, name: 'Samochód' },
			],
			newKoszta: this.getEmptyForm()
		};
	},
	computed: {
		koszty() {
			return this.lokalneKoszty;
		}
	},
	mounted() {
		this.modalObj = new Modal(this.$refs.modalEle);
	},

	methods: {
		resetForm() {
			this.editingId = null;
			this.addingNew = false;
			this.newKoszta = this.getEmptyForm();
		},
		getEmptyForm() {
			return {
				id: null,
				delegacja_id: this.delegacja?.id,
				typ: this.typyKosztow?.[0]?.id ?? null,
				metoda: 0,
				kwota: '',
				waluta: 'PLN',
				data: new Date().toISOString().slice(0, 10),
				kurs: null
			};
		},
		getTypName(id) {
			const typ = this.typyKosztow.find(x => x.id == id);
			return typ ? typ.name : '';
		},
		addKoszta() {
			this.addingNew = true;
			this.newKoszta = this.getEmptyForm();
		},

		cancelNewKoszta() {
			this.addingNew = false;
			this.newKoszta = this.getEmptyForm();
		},

		editKoszta(id) {
			this.editingId = id;
		},

		saveNewKoszta() {
			const koszt = {
				...this.newKoszta,
				id: 'new_' + Date.now()
			};

			this.lokalneKoszty.push(koszt);
			this.$emit('save-koszta', { ...this.newKoszta });
			this.resetForm();
		},

		updateKoszta(koszta) {
			const index = this.lokalneKoszty.findIndex(x => x.id === koszta.id);

			if (index !== -1) {
				this.lokalneKoszty[index] = { ...koszta };
			}

			this.$emit('update-koszta', { ...koszta });
			this.resetForm();
		},

		deleteKoszta(id) {
			Toast.fire({
				toast: false,
				icon: 'warning',
				title: 'Usuwanie celu delegacji',
				html: 'Czy na pewno chcesz usunąć pobraną kwotę?',
				showDenyButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Tak',
				denyButtonText: 'Nie',
				timer: false,
				position: 'center'
			}).then((result) => {
				if (result.isConfirmed) {

					this.lokalneKoszty = this.lokalneKoszty.filter(koszt => koszt.id !== id);

					this.$emit("delete-koszta", id);
					this.resetForm();
				}

			});
		},

		show() {
			this.lokalneKoszty = [...(this.delegacja?.koszty ?? [])];
			this.modalObj.show();
		},
		errorMsg(resp) {
			Toast.fire({
				position: 'top-end',
				toast: true,
				icon: 'warning',
				title: 'Błąd!',
				html: resp,
				showClass: { popup: 'animate__animated animate__fadeInDown' },
				hideClass: { popup: 'animate__animated animate__fadeOutUp' },
				timer: 2500,
				timerProgressBar: true,
				showConfirmButton: false,
				showCloseButton: true
			});
		},


		hide() {
			this.resetForm();

			if (this.modalObj) {
				this.modalObj.hide();
			}
		}
	}
};
</script>

<style>
.position-absolute {
	background: white;
	max-height: 200px;
	overflow-y: auto;
	border: 1px solid #ddd;
}
</style>